import React from 'react';
import {
  classNames,
  containerClassNames,
  ContainerClassNameProps,
  flowClassNames,
  FlowClassNameProps,
  layoutClassNames,
  LayoutClassNameProps,
} from './classNames';

export interface ListGroupProps
  extends React.HTMLAttributes<HTMLDivElement>,
    ContainerClassNameProps,
    FlowClassNameProps,
    LayoutClassNameProps {}

const ListGroup = React.forwardRef<HTMLDivElement, ListGroupProps>(({
  className,
  children,
  container,
  display,
  flexGrow,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  overflowY,
  ...props
}, ref) => (
  <div
    ref={ref}
    className={classNames(
      'list-group',
      containerClassNames({ container }),
      flowClassNames({
        display,
        flexGrow,
        overflowY,
      }),
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </div>
));

ListGroup.displayName = 'ListGroup';

export default ListGroup;
